import React from 'react';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { useRemoveAlignmentMutation } from '../../../../../api/useRemoveAlignmentMutation';
import { toast } from '../../../../../../CommonComponents/OPL/Toast/Toast';
import { MESSAGES } from '../../../../../../CommonConstants';
import { AlignmentDTO } from '../../../../../api/useOverviewQuery';

interface Props {
  onClose(): void;
  alignment: AlignmentDTO;
}

export const RemoveConfirmationModal = ({ onClose, alignment }: Props) => {
  const {
    mutateAsync: removeAlignment,
    isLoading: isRemovingAlignment,
  } = useRemoveAlignmentMutation();

  const handleRemoveAlignment = async () => {
    try {
      await removeAlignment(alignment.id);
    } catch (err) {
      console.error(err);

      toast.error(MESSAGES.GENERIC_ERROR);
    }
  };

  return (
    <Modal isOpen onRequestClose={onClose} size="medium" contentLabel="Delete Model">
      <ModalHeader variant="warning">Remove Comparison</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Text>
          Are you sure you want to remove comparison with {alignment.name}? You will need to invite
          him/her again to connect.
        </Text>
      </ModalBody>

      <ModalFooter>
        <Button onClick={onClose} variant="subtleInactive" autoFocus mr="12">
          Cancel
        </Button>

        <Button variant="error" onClick={handleRemoveAlignment} isLoading={isRemovingAlignment}>
          Remove
        </Button>
      </ModalFooter>
    </Modal>
  );
};
